import {createTheme} from '@mui/material/styles';


export const theme = createTheme({

    palette: {
        primary: {
            main: "#495BFF",
            light: '#131313',
        },
        secondary: {
            main: "#FFF",
        },
        info: {
            main: "#E40613",
        },
        success: {
            main: "#FED001"
        },
        action: {
            main: "#FFFFFF"
        },
        text: {
            primary: '#484848'
        }

    },
    typography: {
        fontFamily: ['Inter',  'sans-serif'].join(','),
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    paddingLeft: 10
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 8
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",

            },
            styleOverrides: {
                root: {
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 16,
                    textTransform: "none",
                    paddingLeft: 24,
                    paddingRight: 24,
                    paddingTop:4,
                    paddingBottom: 4,
                    boxShadow: 0,
                    filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.10))',



                },

            }
        },


    }


})
